export default __webpack_public_path__ + "static/ni-d30c03773b8ce54120334c712f6c79f9.svg";